import Error from "@/views/404";
import Registration from "@/views/registration/anketa/00_registration"
import RegistrationThanks from "@/views/registration/anketa/01_registrationThanks"
import PassportData from "@/views/registration/anketa/02_passportData"
import Address from "@/views/registration/anketa/03_address"
import Employment from "@/views/registration/anketa/04_employment"
import additionalIncome from "@/views/registration/anketa/05_additionalIncome"
import relativeContacts from "@/views/registration/anketa/06_relativeContacts"
import refining from "@/views/registration/anketa/07_refining"
import purpose from "@/views/registration/anketa/08_purpose"
import obtaining from "@/views/registration/anketa/09_obtaining"
import confirmation from "@/views/registration/anketa/10_confirmation"
import Conditions from "@/views/registration/anketa/11_conditions"
import Treatment from "@/views/registration/anketa/12_treatment"
import Decline from "@/views/registration/anketa/decline"

export const registration = [
    {
        path: 'registration',
        name: 'RegistrationStep',
        component: Registration
    },
    {
        path: 'registration-thanks',
        name: 'RegistrationThanks',
        component: RegistrationThanks,
        meta: {}
    },

];

export const anketa = [
    {
        path: 'passport-data',
        name: 'PassportData',
        component: PassportData,
        meta: {requireAuth: true}
    },
    {
        path: 'address',
        name: 'Address',
        component: Address,
        meta: {requireAuth: true}
    },
    {
        path: 'employment',
        name: 'Employment',
        component: Employment,
        meta: {requireAuth: true}
    },
    {
        path: 'additional-income',
        name: 'AdditionalIncome',
        component: additionalIncome,
        meta: {requireAuth: true}
    },
    {
        path: 'relative-contacts',
        name: 'RelativeContacts',
        component: relativeContacts,
        meta: {requireAuth: true}
    },
    {
        path: 'refining',
        name: 'Refining',
        component: refining,
        meta: {requireAuth: true}
    },
    {
        path: 'purpose',
        name: 'Purpose',
        component: purpose,
        meta: {requireAuth: true}
    },
    {
        path: 'obtaining',
        name: 'Obtaining',
        component: obtaining,
        meta: {requireAuth: true}
    },
    {
        path: 'confirmation',
        name: 'Confirmation',
        component: confirmation,
        meta: {requireAuth: true}
    },
    {
        path: 'conditions',
        name: 'Conditions',
        component: Conditions,
        meta: {requireAuth: true}
    },
    {
        path: 'treatment',
        name: 'Treatment',
        component: Treatment,
        meta: {requireAuth: true}
    },
    {
        path: 'decline',
        name: 'Decline',
        component: Decline,
        meta: {requireAuth: true}
    }
];